<div *ngIf="isLoading" class="flex justify-content-center align-items-center h-full">
  <p-progressSpinner aria-label="Loading item details"></p-progressSpinner>
</div>

<section *ngIf="!isLoading && item" class="surface-ground h-full overflow-y-auto p-4">
  <p-toast></p-toast>

  <div class="flex flex-wrap justify-content-between align-items-start mb-4">
    <div class="flex align-items-center">
      <div>
        <h1 class="text-blue-800 text-3xl font-bold m-0">
          {{ item.erpItemNameE || item.erpItemNumber || 'Item Details' }}
        </h1>
        <div class="mt-2 text-600">
          <span class="font-medium">Item No:</span>
          <span>{{ item.erpItemNumber || 'N/A' }}</span>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap align-items-center gap-2">
      <p-tag
        [value]="(item.erpItemStatus || 'Unknown').toUpperCase()"
        [severity]="getStatusSeverity(item.erpItemStatus ?? '')"
        [rounded]="true"
      ></p-tag>
      <p-button label="Back" icon="pi pi-arrow-left" styleClass="p-button-text" (onClick)="goBackToList()"></p-button>
      <p-button label="Edit Item" icon="pi pi-pencil" (onClick)="editItem()"></p-button>
    </div>
  </div>

  <div class="card p-4 mb-4 surface-card border-round-md shadow-2">
    <div class="grid text-sm">
      <div class="col-12 md:col-6 lg:col-4"><strong>Item ID:</strong> {{ item.itemId }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>ERP Item ID:</strong> {{ item.erpItemId ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Item No:</strong> {{ item.erpItemNumber ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Item Name Arabic:</strong> {{ item.erpItemNameA ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Item Name English:</strong> {{ item.erpItemNameE ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Item UOM:</strong> {{ item.erpItemUom ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Vendor Catalog:</strong> {{ item.erpVendorCatalog ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Status:</strong> {{ item.erpItemStatus ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Created By:</strong> {{ item.createdBy ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Updated By:</strong> {{ item.updatedBy ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Deleted By:</strong> {{ item.deletedBy ?? 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Created At:</strong> {{ formatDate(item.createdAt) }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Updated At:</strong> {{ formatDate(item.updatedAt) }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Deleted At:</strong> {{ formatDate(item.deletedAt) }}</div>
    </div>
  </div>

  <p-panel header="Related Data" styleClass="mb-4">
    <div class="flex flex-wrap gap-2 mb-3">
      <p-chip [label]="item.brand?.brandName || 'No Brand'" icon="pi pi-tags"></p-chip>
      <p-chip [label]="item.subBrand?.subBrandName || 'No Sub Brand'" icon="pi pi-sitemap"></p-chip>
      <p-chip [label]="item.business?.businessName || 'No Business'" icon="pi pi-building"></p-chip>
      <p-chip [label]="item.category?.name || 'No Category'" icon="pi pi-folder"></p-chip>
      <p-chip [label]="item.subCategory?.name || 'No Sub Category'" icon="pi pi-folder-open"></p-chip>
    </div>

    <div class="grid text-sm">
      <div class="col-12 md:col-6 lg:col-4"><strong>Brand:</strong> {{ item.brand?.brandName || 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Sub Brand:</strong> {{ item.subBrand?.subBrandName || 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Business:</strong> {{ item.business?.businessName || 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Category:</strong> {{ item.category?.name || 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Sub Category:</strong> {{ item.subCategory?.name || 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Supplier:</strong> {{ item.supplier?.supplierName || 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Supplier Site:</strong> {{ item.supplierSite?.supplierSiteName || 'N/A' }}</div>
      <div class="col-12 md:col-6 lg:col-4"><strong>Supplier ID:</strong> {{ item.supplierId ?? 'N/A' }}</div>
    </div>
  </p-panel>
</section>
